import type { FC, PropsWithChildren } from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';

const styles = StyleSheet.create({
  container: { flexDirection: 'column' }
});

export const Column: FC<PropsWithChildren & ViewProps> = ({
  children,
  style,
  ...props
}) => (
  <View style={[styles.container, style]} {...props}>
    {children}
  </View>
);
